import React from 'react'
import clsx from 'clsx'
import ProgressBar from '@/components/ui/ProgressBar'
import type { KegiatanTahap } from '@/types/pocketbase'

interface TahapProgressProps {
  tahap: KegiatanTahap[]
}

export default function TahapProgress({ tahap }: TahapProgressProps) {
  const total = tahap.length || 12
  const selesai = tahap.filter((t) => t.status === 'selesai').length
  const ongoing = tahap.find((t) => t.status === 'ongoing')
  const progress = total > 0 ? Math.round((selesai / total) * 100) : 0

  const getBadgeColor = (status: string) => {
    switch (status) {
      case 'selesai':
        return 'bg-success text-white'
      case 'ongoing':
        return 'bg-primary text-white'
      default:
        return 'bg-gray-200 text-text-secondary'
    }
  }

  const getBarColor = (status: string) => {
    switch (status) {
      case 'selesai':
        return 'bg-success'
      case 'ongoing':
        return 'bg-primary'
      default:
        return 'bg-gray-200'
    }
  }

  return (
    <div className="space-y-3">
      <div>
        <div className="flex justify-between items-center mb-1">
          <span className="text-xs font-semibold text-text-secondary">Progress Keseluruhan</span>
          <span className="text-xs font-bold text-primary">{progress}%</span>
        </div>
        <ProgressBar value={selesai} max={total} color="primary" size="md" />
      </div>

      {ongoing && (
        <p className="text-xs text-text-secondary">
          <span className="font-semibold text-primary">Sekarang:</span>{' '}
          {ongoing.no_tahap}. {ongoing.nama}
        </p>
      )}

      <div className="flex flex-wrap gap-1.5">
        {tahap.length === 0
          ? Array.from({ length: 12 }, (_, i) => (
              <div
                key={i}
                className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center text-xs font-medium text-text-secondary"
              >
                {i + 1}
              </div>
            ))
          : tahap.map((t) => (
              <div
                key={t.id}
                className={clsx(
                  'w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold transition-all',
                  getBadgeColor(t.status)
                )}
                title={`${t.no_tahap}. ${t.nama} (${t.status})`}
              >
                {t.no_tahap}
              </div>
            ))}
      </div>

      <div className="flex gap-4">
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-full bg-success" />
          <span className="text-xs text-text-secondary">Selesai ({selesai})</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-full bg-primary" />
          <span className="text-xs text-text-secondary">Sedang ({tahap.filter((t) => t.status === 'ongoing').length})</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-full bg-gray-200" />
          <span className="text-xs text-text-secondary">Pending ({total - selesai - tahap.filter((t) => t.status === 'ongoing').length})</span>
        </div>
      </div>

      {tahap.length > 0 && (
        <div className="mt-3 flex gap-1">
          {tahap.map((t) => (
            <div
              key={t.id}
              className={clsx('h-1.5 flex-1 rounded-full transition-all', getBarColor(t.status))}
              title={`${t.no_tahap}. ${t.nama}`}
            />
          ))}
        </div>
      )}
    </div>
  )
}
